module.exports = __webpack_public_path__ + "fonts/DM_Sans-400-latin9.7c87a64.woff2";